"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topLeftToBottomRightSortPositions = exports.topToBottomMiddleSortPositions = exports.getFirstEmptySlot = void 0;
const position_1 = require("./position");
const getFirstEmptySlot = (state, sortPositions = exports.topToBottomMiddleSortPositions) => {
    const emptyPositions = [];
    for (let y = 0; y < state.height; y++) {
        for (let x = 0; x < state.width; x++) {
            if (state.getPieceIdAtPosition(x, y)) {
                continue;
            }
            emptyPositions.push((0, position_1.packPosition)(x, y));
        }
    }
    if (emptyPositions.length === 0) {
        return null;
    }
    emptyPositions.sort(sortPositions);
    return emptyPositions[0];
};
exports.getFirstEmptySlot = getFirstEmptySlot;
const SORT_A_FIRST = -1;
const SORT_A_SECOND = 1;
const topToBottomMiddleSortPositions = (a, b) => {
    const yA = (0, position_1.unpackY)(a);
    const yB = (0, position_1.unpackY)(b);
    if (yA < yB) {
        return SORT_A_FIRST;
    }
    if (yA > yB) {
        return SORT_A_SECOND;
    }
    const xA = (0, position_1.unpackX)(a);
    const xB = (0, position_1.unpackX)(b);
    // todo tie this into board size
    const distanceFromMiddleA = Math.abs(xA - 3);
    const distanceFromMiddleB = Math.abs(xB - 3);
    if (distanceFromMiddleA < distanceFromMiddleB) {
        return SORT_A_FIRST;
    }
    if (distanceFromMiddleA > distanceFromMiddleB) {
        return SORT_A_SECOND;
    }
    return SORT_A_FIRST;
};
exports.topToBottomMiddleSortPositions = topToBottomMiddleSortPositions;
const topLeftToBottomRightSortPositions = (a, b) => {
    const yA = (0, position_1.unpackY)(a);
    const yB = (0, position_1.unpackY)(b);
    if (yA < yB) {
        return SORT_A_FIRST;
    }
    if (yA > yB) {
        return SORT_A_SECOND;
    }
    const xA = (0, position_1.unpackX)(a);
    const xB = (0, position_1.unpackX)(b);
    if (xA < xB) {
        return SORT_A_FIRST;
    }
    if (xA > xB) {
        return SORT_A_SECOND;
    }
    return SORT_A_FIRST;
};
exports.topLeftToBottomRightSortPositions = topLeftToBottomRightSortPositions;
